import React from "react";
import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import EconomicalTariffUsageDTO from "features/economicalTariff/dtos/EconomicalTariffUsageDTO";
import { useTranslation } from "react-i18next";
import InfoItemMobile from "features/shared/components/infoItem/InfoItemMobile";

type Props = {
  usage: EconomicalTariffUsageDTO;
};

const EconomicalTariffUsage = ({ usage }: Props) => {
  // translations
  const t = useTranslation("economicalTariff\\economicalTariff").t;

  return (
    <div className="row no-gutters align-items-center">
      <div className="col-lg-3">
        <InfoItemMobile
          title={t("economicalTariffUsage.placeOfDelivery")}
          value={usage.placeOfDelivery!}
          hideTitleOn="lg"
        />
      </div>
      <div className="col-lg-5 px-lg-3 text-lg-center">
        <InfoItemMobile
          title={t("economicalTariffUsage.usedFor")}
          value={usage.usedFor!}
          hideTitleOn="lg"
          valueClassName="text-right text-lg-center"
        />
      </div>
      <div className="col-lg-2 text-lg-center">
        <InfoItemMobile
          title={t("economicalTariffUsage.paymentIdentification")}
          value={!usage.paymentIdentification ? "-" : usage.paymentIdentification}
          hideTitleOn="lg"
          valueClassName="text-right text-lg-center"
        />
      </div>
      <div className="col-lg-2 text-lg-right">
        <InfoItemMobile
          title={t("economicalTariffUsage.amount")}
          value={<PriceFormatter amount={usage.amount!} currency="CZK" />}
          hideTitleOn="lg"
        />
      </div>
    </div>
  );
};

export default EconomicalTariffUsage;
